import { api } from "api";
import { getRefetchInterval, useRefetchMeta } from "@vyne-shared/utils/invalidateQueriesFor";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

/**
 * Client hook to query for the individual event history of a Patient/Responsible Party.
 * @param patientId The ID of the P/RP to query for.
 * @returns React Query properties.
 */
export function usePatientHistory(patientId: number) {
    return useQuery({
        queryKey: ["transactionHistory", patientId],
        queryFn: async (context) => await api.patient.history(patientId, context.signal),
        placeholderData: keepPreviousData,
        meta: useRefetchMeta(1000),
        refetchInterval: getRefetchInterval,
    });
}
